import React from 'react';
import PdfViewer from '../marketing/PdfViewer';

const DECK_URL = 'https://global.divhunt.com/c928d7e23e80922af87bb3d8dde1fd63_2994878.pdf';

export default function CWSalesDeck() {
  return (
    <PdfViewer
      eyebrow="Sales deck"
      title="Present with confidence."
      intro="View the CW sales deck here, open it full screen, or download a copy."
      url={DECK_URL}
      frameTitle="CW sales deck"
    />
  );
}